import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
// Importar la interfaz y el servicio actualizado
import { SolicitarVisitaService, PagedRequestOptions } from 'src/app/services/solicitar-visita.service';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { EspecialidadesService } from 'src/app/services/especialidades.service';
import { StorageService } from 'src/app/services/storage.service';
import { Subscription, Subject, merge, of as observableOf } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, catchError } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { PaginatorIntl } from 'src/app/paginator-intl';
import { SharedModule } from '@app/shared/shared.module';
import { TipoServicioService } from '@app/services/tipo-servicio.service';
import { FacturacionService } from '@app/services/facturacion.service';
import { ClientesService } from 'src/app/services/clientes.service';

@Component({
  selector: 'app-solicitudes-validadas',
  standalone: true,
  imports: [
    CommonModule, RouterModule, MatTableModule, MatPaginatorModule,
    MatSortModule, MatButtonModule, MatIconModule, MatChipsModule,
    MatCardModule, MatFormFieldModule, MatInputModule, MatTooltipModule,
    MatProgressSpinnerModule, MatSelectModule, SharedModule
  ],
  templateUrl: './solicitudes-validadas.component.html',
  styleUrls: ['./solicitudes-validadas.component.scss'],
  providers: [
    { provide: MatPaginatorIntl, useClass: PaginatorIntl }
  ]
})
export class SolicitudesValidadasComponent implements OnInit, AfterViewInit, OnDestroy {  
  baseDisplayedColumns: string[] = [
    'id', 
    'fechaIngreso',
    'local', 
    'zona',
    'especialidad',
    'ticketGruman', 
    'generado_por',
    'tipoServicio', 
    'tipo_solicitud',
    'tecnico', 
    'tecnico_2', 
    'fecha_hora_inicio_servicio',
    'validada_por', 
    'fecha_hora_validacion',
    'observaciones',     
    'actions'
  ];
  displayedColumns: string[] = [...this.baseDisplayedColumns];
  public esGruman: boolean = false;
  dataSource = new MatTableDataSource<any>();
  loading = true;
  totalItems = 0;
  selectedServiceType: string = '';
  tiposServicio: any[] = [];

  selectedCompany: any = null;
  mesesFacturacion: string[] = []; 
  selectedMesFacturacion: string = '';

  meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  anios: number[] = [];
  selectedMes: string = '';
  selectedAnio: string = '';
  public isGruman: boolean = false;
  public clientes: any[] = [];
  public selectedClientId: number | null = null;
  private companySubscription: Subscription | null = null;
  private searchSubject = new Subject<string>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('input') input!: ElementRef;

  especialidades: { [key: number]: string } = {};
  isReadOnly: boolean = false;

  constructor(
    private solicitarVisitaService: SolicitarVisitaService,
    private especialidadesService: EspecialidadesService,
    private tipoServicioService: TipoServicioService,
    private facturacionService: FacturacionService,
    private clientesService: ClientesService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private storage: StorageService
  ) {}

  ngOnInit() {
    this.generarAnios();
    this.loadEspecialidades();
    this.getTiposServicio();
    
    // Capturar si venimos desde el Dashboard con un mes específico
    this.route.queryParams.subscribe((params: any) => {
      if (params['mesFacturacion']) {
        const parts = params['mesFacturacion'].split(' ');
        if (parts.length === 2) {
          this.selectedMes = parts[0];
          this.selectedAnio = parts[1];
        }
      }
    });
    
    this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(() => {
      this.paginator.pageIndex = 0;
      this.loadSolicitudes();
    });

    this.companySubscription = this.storage.companyChange$.subscribe((company: any) => {
      this.selectedCompany = company;

      this.isGruman = this.selectedCompany?.nombre?.trim().toUpperCase() === 'GRUMAN';
      this.selectedClientId = null;
      if (this.isGruman) {
        this.loadClientes();
      }
      
      this.updateDisplayedColumns(this.selectedCompany);

      if (this.paginator) {
        this.paginator.pageIndex = 0;
        this.loadSolicitudes();
      }

      const user = this.storage.getItem('currentUser');
      if (user && user.selectedCompany) {      
        this.selectedCompany = user.selectedCompany;
        // 🛠️ FIX: Inicializar el filtro de cliente en la carga si es GRUMAN
        this.isGruman = this.selectedCompany.nombre?.trim().toUpperCase() === 'GRUMAN';
        this.updateDisplayedColumns(this.selectedCompany);
        if (this.isGruman) {
          this.loadClientes();
        }
      } else {      
        this.updateDisplayedColumns(null);
      }
    });

    const user = this.storage.getItem('currentUser');
    if (user && user.selectedCompany) {
      this.selectedCompany = user.selectedCompany;
      this.updateDisplayedColumns(this.selectedCompany);
      this.isReadOnly = user?.profile === 'readonly';
    } else {
      this.updateDisplayedColumns(null);
    }
  }

  // Cargar catálogo de clientes para el dropdown
  loadClientes(): void {
    this.clientesService.getClientesWithGruman().subscribe({
      next: (clientes: any[]) => this.clientes = clientes || [],
      error: (err: any) => console.error('Error al cargar clientes:', err)
    });
  }

  // Evento al seleccionar un cliente en la vista GRUMAN
  onClientFilterChange(): void {
    if (this.paginator) this.paginator.pageIndex = 0;
    this.loadSolicitudes();
  }

  ngAfterViewInit() {
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(startWith({}))
      .subscribe(() => this.loadSolicitudes());
  }

  ngOnDestroy() {
    if (this.companySubscription) {
      this.companySubscription.unsubscribe();
    }
  }

  getTiposServicio(): void {
    this.tipoServicioService.findAll().subscribe({
      next: (data: any) => {
        this.tiposServicio = data;
      },
      error: (err: any) => console.error('Error cargando tipos de servicio', err)
    });
  }

  private updateDisplayedColumns(company: any) {
    const newCols = [...this.baseDisplayedColumns];
    this.esGruman = false; // Reinicia por defecto

    // Verificación robusta
    if (company && company.nombre) {
      const nombreLimpio = company.nombre.trim().toUpperCase();
      if (nombreLimpio === 'GRUMAN') {
        this.esGruman = true;
      }
    }

    // Si es Gruman, añade la columna 'status'
    if (this.esGruman) {
      newCols.splice(2, 0, 'cliente');
      // Intentamos insertar 'status' antes de 'actions'
      const actionsIndex = newCols.indexOf('actions');
      if (actionsIndex > -1) {
        newCols.splice(actionsIndex, 0, 'status');
      } else {
        newCols.push('status'); // Fallback si 'actions' no estuviera
      }
    }

    this.displayedColumns = newCols;
  }

  loadSolicitudes() {
    this.loading = true;

    let mesFacturacionStr = '';
    if (this.selectedMes) mesFacturacionStr += this.selectedMes;
    if (this.selectedAnio) mesFacturacionStr += (mesFacturacionStr ? ' ' : '') + this.selectedAnio;

    const options: PagedRequestOptions = {
      page: this.paginator.pageIndex + 1,
      limit: this.paginator.pageSize,
      searchTerm: this.input.nativeElement.value,
      serviceType: this.selectedServiceType,
      mesFacturacion: mesFacturacionStr || undefined,
      sortBy: this.sort.active || 'id',
      sortOrder: this.sort.direction || 'desc',
    };
      
    if (this.isGruman) {
      if (this.selectedClientId) {
        options.clientId = this.selectedClientId;
      }
    } else if (this.selectedCompany?.id) {
      options.clientId = this.selectedCompany.id;
    }

    this.solicitarVisitaService.getSolicitudesValidadasPaginado(options)
    .pipe(
      catchError(() => observableOf(null))
    ).subscribe({
      next: (response:any) => {
        this.dataSource.data = response ? response.data : [];
        this.totalItems = response ? response.total : 0;
        this.loading = false;
      },
      error: (error:any) => {
        console.error('Error cargando solicitudes validadas:', error);
        this.loading = false;
      }
    });
  }

  generarAnios(): void {
    const currentYear = new Date().getFullYear();
    for (let y = 2023; y <= currentYear + 2; y++) {
      this.anios.push(y);
    }
  }

  onDateFilterChange() {
    if (this.paginator) this.paginator.pageIndex = 0;
    this.loadSolicitudes();
  }

  loadEspecialidades() {
    this.especialidadesService.findAll().subscribe({
      next: (especialidades:any) => {
        this.especialidades = especialidades.reduce((acc:any, esp:any) => {
          acc[esp.id] = esp.nombre;
          return acc;
        }, {} as { [key: number]: string });
      }
    });
  }
  
  applyFilter() {
    this.searchSubject.next(this.input.nativeElement.value);
  }

  onServiceTypeChange() {
    this.paginator.pageIndex = 0; // Volvemos a la página 1
    this.loadSolicitudes();       // Recargamos la tabla
  }

  onFacturacionChange() {
    this.paginator.pageIndex = 0;
    this.loadSolicitudes();
  }

  resetFilters() {
    this.input.nativeElement.value = '';
    this.selectedServiceType = '';
    this.selectedClientId = null;
    this.selectedMesFacturacion = '';
    this.paginator.pageIndex = 0;
    this.sort.active = 'id';
    this.sort.direction = 'desc';
    this.selectedMes = '';
    this.selectedAnio = '';
    this.getTiposServicio();
    this.loadSolicitudes();
  }

  canViewDetail(row: any): boolean {
    if (row.facturacion && (row.facturacion.is_cerrada === true || row.facturacion.is_cerrada === 1)) {
      return false;
    }
    return true;
  }

  verDetalle(id: number) {
    this.router.navigate(['transacciones/solicitudes-de-visita/ver-solicitud/validada', id]);
  }

  reabrirSolicitud(solicitud: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { title: 'Reabrir Solicitud', message: '¿Está seguro que desea reabrir esta solicitud?' }
    });

    dialogRef.afterClosed().subscribe((result:any) => {
      if (result) {
        this.solicitarVisitaService.reabrirSolicitud(solicitud.id).subscribe({
          next: () => {
            this.snackBar.open('Solicitud reabierta exitosamente', 'Cerrar', { duration: 3000 });
            this.loadSolicitudes();
          },
          error: (error:any) => {
            console.error('Error al reabrir la solicitud:', error);
            this.snackBar.open('Error al reabrir la solicitud', 'Cerrar', { duration: 3000 });
          }
        });
      }
    });
  }

  editarSolicitud(row: any): void {
    this.router.navigate([`/transacciones/solicitudes-de-visita/modificar/${row.id}`]);
  }

  async downloadPdf(solicitud: any) {
    try {
      // 1. Mostrar loading
      Swal.fire({ title: 'Obteniendo equipos...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      // 2. Traer el detalle de la solicitud (para los nombres) y el JSON del checklist (para saber cuáles se intervinieron)
      const [detalle, checklist] = await Promise.all([
        this.solicitarVisitaService.getSolicitudVisita(solicitud.id).toPromise(),
        this.solicitarVisitaService.getSolicitudVisitaChecklist(solicitud.id).toPromise().catch(() => null)
      ]);
      
      Swal.close();

      let equiposIntervenidos: any[] = [];

      // 3. Extraer los equipos de la nueva arquitectura JSON
      if (checklist?.is_climate && checklist?.climate_data) {
        // Obtenemos los IDs que vienen dentro del JSON
        const idsIntervenidos = checklist.climate_data.map((cd: any) => Number(cd.activo_fijo_id));
        
        // Cruzamos esos IDs con los activos del local para sacar el código y marca
        if (detalle.local?.activoFijoLocales) {
          equiposIntervenidos = detalle.local.activoFijoLocales.filter((af: any) => 
            idsIntervenidos.includes(Number(af.id))
          );
        }
      } 
      // 3.1 Fallback por si hay tickets viejos que sí usaron la tabla relacional
      else if (detalle.activoFijoRepuestos?.length > 0) {
        equiposIntervenidos = detalle.activoFijoRepuestos.map((afr: any) => afr.activoFijo);
      }

      // 4. Construir el Modal si hay equipos
      if (equiposIntervenidos.length > 0) {
        
        let checkboxesHtml = '<div style="text-align: left; max-height: 250px; overflow-y: auto; margin-top: 10px; border: 1px solid #eee; padding: 10px; border-radius: 8px;">';
        
        checkboxesHtml += `
          <div style="margin-bottom: 10px; border-bottom: 1px solid #ccc; padding-bottom: 8px;">
            <input type="checkbox" id="selectAllActivos" checked style="cursor: pointer; transform: scale(1.2); margin-right: 8px;"
            onchange="const checkboxes = document.querySelectorAll('.activo-checkbox'); checkboxes.forEach(cb => cb.checked = this.checked);">
            <label for="selectAllActivos" style="font-weight: bold; cursor: pointer; font-size: 15px;">Seleccionar Todos</label>
          </div>`;

        equiposIntervenidos.forEach((equipo: any) => {
          // Mostrar el código y el tipo (Ej: AC-01 - Split Muro)
          const nombreEquipo = `${equipo.codigo_activo || 'Sin Código'} - ${equipo.tipo_equipo || 'Equipo'}`;
          
          checkboxesHtml += `
            <div style="margin-bottom: 8px; display: flex; align-items: center;">
              <input type="checkbox" class="activo-checkbox" value="${equipo.id}" id="equipo_${equipo.id}" checked style="cursor: pointer; transform: scale(1.1); margin-right: 8px;">
              <label for="equipo_${equipo.id}" style="cursor: pointer; margin: 0;">${nombreEquipo}</label>
            </div>
          `;
        });
        checkboxesHtml += '</div>';

        const result = await Swal.fire({
          title: 'Configurar Reporte',
          html: `<p>Selecciona los equipos que deseas incluir en el PDF:</p>${checkboxesHtml}`,
          showCancelButton: true,
          confirmButtonText: 'Descargar PDF',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#3085d6',
          preConfirm: () => {
            const selected = Array.from(document.querySelectorAll('.activo-checkbox:checked')).map((cb: any) => parseInt(cb.value));
            if (selected.length === 0) {
              Swal.showValidationMessage('Debes seleccionar al menos un equipo');
            }
            return selected;
          }
        });

        if (result.isConfirmed) {
          this.ejecutarDescargaPdf(solicitud, result.value);
        }

      } else {
        // Si es un ticket de gasfitería (sin equipos), se descarga directo
        this.ejecutarDescargaPdf(solicitud);
      }
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudo obtener la información para generar el PDF', 'error');
    }
  }

  // Este método se mantiene igual que en la respuesta anterior
  private ejecutarDescargaPdf(solicitud: any, activosIds?: number[]) {
    Swal.fire({ title: 'Generando documento...', text: 'Por favor espere', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
    
    this.solicitarVisitaService.downloadPdf(solicitud.id, activosIds).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `solicitud-${solicitud.id}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        Swal.close();
      },
      error: () => {
        Swal.fire('Error', 'Hubo un problema al generar o descargar el PDF', 'error');
      }
    });
  }

  exportarExcel() {
    Swal.fire({
      title: 'Generando exportación...',
      text: 'Esto puede tardar unos segundos, por favor espera.',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    let mesFacturacionStr = '';
    if (this.selectedMes) mesFacturacionStr += this.selectedMes;
    if (this.selectedAnio) mesFacturacionStr += (mesFacturacionStr ? ' ' : '') + this.selectedAnio;

    // 1. Construir las opciones (Inyectamos el status directamente por seguridad)
    const options: PagedRequestOptions | any = {
      export: true,
      searchTerm: this.input.nativeElement.value,
      serviceType: this.selectedServiceType,
      sortBy: this.sort.active || 'id',
      sortOrder: this.sort.direction || 'desc',
      mesFacturacion: mesFacturacionStr || undefined,
      status: 'validada'
    };

    if (this.isGruman) {
      if (this.selectedClientId) {
        options.clientId = this.selectedClientId;
      }
    } else if (this.selectedCompany?.id) {
      options.clientId = this.selectedCompany.id;
    }

    // 2. Llamada al servicio
    this.solicitarVisitaService.descargarExcelSolicitudes(options).subscribe({
      next: (response: any) => {
        if (!response || !response.data || response.data.length === 0) {
          Swal.fire('Sin datos', 'No hay solicitudes rechazadas para exportar.', 'warning');
          return;
        }

        // 3. Delegar la generación del Excel al servicio maestro
        this.solicitarVisitaService.exportarExcelMaestro(response.data, 'Validadas');
      },
      error: (err: any) => {
        console.error('Error al exportar:', err);
        Swal.close();
        Swal.fire('Error', 'Hubo un problema al generar el Excel.', 'error');
      }
    });
  }
}